import React from 'react';
import { Paper, Typography, Button } from '@mui/material';
import { Add, Image as ImageIcon } from '@mui/icons-material';

interface EmptyProductsStateProps {
  searchTerm: string;
  onAddProduct: () => void;
}

const EmptyProductsState: React.FC<EmptyProductsStateProps> = ({ searchTerm, onAddProduct }) => {
  return (
    <Paper sx={{ p: 6, textAlign: 'center' }}>
      <ImageIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
      <Typography variant="h5" color="text.secondary" gutterBottom>
        {searchTerm ? 'No products found' : 'No products yet'}
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>
        {searchTerm 
          ? 'Try adjusting your search terms'
          : 'Start by adding your first authentic product to the catalog'
        }
      </Typography>
      {!searchTerm && (
        <Button
          variant="contained"
          size="large"
          startIcon={<Add />}
          onClick={onAddProduct}
        >
          Add First Product
        </Button>
      )}
    </Paper>
  );
};

export default EmptyProductsState;